export default "__VITE_ASSET__BiQkbDn9__"